
let cartData = null;
const cosmoCareVariantId = 46892709707997; // COSMO Care - Monthly
const cosmoCareSellingPlanId = 6194397405 // Delivery every 30 Days

const cosmoCarePlusVariantId= 46892711510237; // COSMO Care - Plus
const cosmoCarePlusSellingPlanId= 6190727389; // Delivery every 30 Days

$(document).ready(function () {
  $('.pick-choose').click(function (e) {
    var param = $(this).attr('variant_id');
    $("#vid").val(param);
  });

  document.querySelectorAll('.pick-choose').forEach(item => {
    item.addEventListener('click', function() {
      let radioButton = item.querySelector('input[type="radio"]');
      radioButton.checked = true; // Set radio button to checked
    });
  });
});

$(document).ready(async (e) => {
  cartData = await fetchCart();
})

async function addCosmoCare() {
  var param=$("#vid").val();

  $("#cosmocareadd").prop('disabled', true);

  cartData = await fetchCart();
  if (cartData) {
    const cosmoCareCartItem = (cartData?.lines?.edges ?? []).find((obj) => {
      const id = obj?.node?.merchandise?.id;
      return (
        id === `gid://shopify/ProductVariant/${cosmoCareVariantId}` ||
        id === `gid://shopify/ProductVariant/${cosmoCarePlusVariantId}`
      );
    });

    if (cosmoCareCartItem) {
      if (!await removeCartItem(cosmoCareCartItem?.node?.id)) {
        $(".action-btn").removeClass('disablebtn');
        return;
      }
    }

    if (param == 2) {
      if (await addCartItem({
        variant_id: cosmoCarePlusVariantId,
        selling_plan_id: cosmoCarePlusSellingPlanId,
        quantity: 1,
      })) {
        localStorage.setItem('cosmocare', 1);
        setTimeout(() => {
          window.location = '/pages/upgrade-accessories';

          setTimeout(() => {
            $(".action-btn").removeClass('disablebtn');                
          }, 1000);
        });
      } else {
        $(".action-btn").removeClass('disablebtn');
      }
    } else if (param == 1) {
      if (await addCartItem({
        variant_id: cosmoCareVariantId,
        selling_plan_id: cosmoCareSellingPlanId,
        quantity: 1,
      })) {
        localStorage.setItem('cosmocare', 1);
        setTimeout(() => {
          window.location = '/pages/upgrade-accessories';

          setTimeout(() => {
            $(".action-btn").removeClass('disablebtn');                
          }, 1000);
        });
      } else {
        $(".action-btn").removeClass('disablebtn');
      }
    } else {
      localStorage.setItem('cosmocare', 0);
      setTimeout(() => {
        window.location = '/pages/upgrade-accessories';

        setTimeout(() => {
          $(".action-btn").removeClass('disablebtn');                
        }, 1000);
      }); 
    }
  } else {
    notify('error', "Cart Retrieval Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.");
    $(".action-btn").removeClass('disablebtn');
  }

  setTimeout(function(){    
    $("#cosmocareadd").prop('disabled', false);
  },3000);
}

function removeCartItem(lineItemId) {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/lines/remove`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          line_ids: Array.isArray(lineItemId) ? lineItemId : [lineItemId],
        }),
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Oops! Removal Failed");
        return resolve(false);
      });
    } else {
      notify('error', "Oops! Removal Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

function addCartItem(lineItem) {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/lines/add`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId,
          items: Array.isArray(lineItem) ? lineItem : [lineItem],
        })
      }).done(function (response) {
        return resolve(true);
      }).fail(function (error) {
        showErrorMessage(error, "Failed to Add to Cart");
        return resolve(false);
      });
    } else {
      notify('error', "Failed to Add to Cart", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

// Get all focusable elements on the page
var focusableElements = document.querySelectorAll('button, [href], input, select, a, textarea, h1, h2, h3, h4, h5, img, [tabindex]:not([tabindex="-1"])');

// Loop through each focusable element and set tabindex to 0
focusableElements.forEach(function (element) {
  element.setAttribute('tabindex', '0');
});
  